import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router";
import { Badge } from "@client/components/ui/Badge";
import { buttonClassName } from "@client/components/ui/button-variants";
import { useHeroParallax } from "@client/hooks/use-hero-parallax";
import { homeCopy } from "@client/locales/id/home";

export function HomeHero() {
  const parallaxRef = useHeroParallax<HTMLDivElement>();

  return (
    <section className="px-4 pt-16 pb-12 sm:px-6 md:pt-24 lg:pt-32">
      <div ref={parallaxRef} className="mx-auto flex max-w-4xl flex-col items-center gap-6 text-center will-change-transform">
        <div className="animate-fade-up">
          <Badge>
            <Sparkles className="size-3.5 text-accent-bright" aria-hidden="true" />
            {homeCopy.badge}
          </Badge>
        </div>

        <h1 className="animate-fade-up text-4xl leading-tight font-semibold tracking-[-0.03em] text-balance [animation-delay:80ms] sm:text-5xl lg:text-7xl">
          <span className="text-gradient">{homeCopy.titleLead} </span>
          <span className="text-gradient-accent animate-shimmer">{homeCopy.titleAccent}</span>
          <span className="text-gradient"> {homeCopy.titleTail}</span>
        </h1>

        <p className="animate-fade-up max-w-2xl text-base leading-relaxed text-pretty text-foreground-muted [animation-delay:160ms] md:text-lg lg:text-xl">
          {homeCopy.description}
        </p>

        <div className="animate-fade-up flex w-full flex-col gap-3 [animation-delay:240ms] sm:w-auto sm:flex-row">
          <a href="#katalog" className={buttonClassName("primary", "lg", "group")}>
            {homeCopy.primaryCta}
            <ArrowRight
              className="size-4 transition-transform duration-200 ease-expo-out group-hover:translate-x-0.5"
              aria-hidden="true"
            />
          </a>
          <Link to="/blog" className={buttonClassName("secondary", "lg")}>
            {homeCopy.secondaryCta}
          </Link>
        </div>
      </div>
    </section>
  );
}
